export const LS = {
  TEMP: 'TEMP',
  JWT: 'JWT'
}
